<template>
  <b-modal ref="modal"
           size="md"
           centered
           hide-footer>
    <input type="file" class="d-none" ref="plannerFile" @change="onUploadPlannerFile">
    <input type="file" class="d-none" ref="financFile" @change="onUploadFinancFile">
    <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{$lang.PCI.Annex.Title}}
          </span>
          <button class="close" @click="onHide">x</button>
        </div>
    </template>
    <div v-show="showSelection">
      <v-select v-model="contract"
                label="referenciaContrato"
                :clearable="false"
                class="m-1 mb-3 text-center"
                :options="contracts"
                v-if="contract.referenciaContrato"
                @input="onLoadContract"></v-select>
    </div>
    <b-card>
      <template #header>
        <strong>{{'Planejamento'}}</strong>
      </template>
      <div class="d-flex flex-column justify-content-center">
        <div class="align-self-center p-2">
          <b-button variant="light" v-if="plannerObj" @click="onRemovePlannerFile">
            <i class="far fa-trash-alt text-danger" style="font-size: 2rem;" v-b-tooltip.hover :title="'Remove Arquivo'"></i>
          </b-button>
          <b-button variant="light" v-if="plannerObj" @click="onDownloadPlanner">
            <i class="fas fa-download text-primary" style="font-size: 2rem;" v-b-tooltip.hover :title="'Download do arquivo'"></i>
          </b-button>
          <b-button variant="light" @click="onClickPlannerFile">
            <i class="fas fa-upload text-third" style="font-size: 2rem;" v-b-tooltip.hover :title="'Upload de arquivo'"></i>
          </b-button>
        </div>
        <b-form-input id="txtPlannerAnnex" disabled v-if="plannerObj" v-model="plannerObj.nome"></b-form-input>
      </div>
    </b-card>
    <b-card>
      <template #header>
        <strong>{{'Financeiro'}}</strong>
      </template>
      <div class="d-flex flex-column justify-content-center">
        <div class="align-self-center p-2">
          <b-button variant="light" v-if="financObj && hasRole(roles.RW_OPER_PCI_DOCUMENTATION)" @click="onRemoveFinancFile">
            <i class="far fa-trash-alt text-danger" style="font-size: 2rem;" v-b-tooltip.hover :title="'Remove Arquivo'"></i>
          </b-button>
          <b-button variant="light" v-if="financObj" @click="onDownloadFinanc">
            <i class="fas fa-download text-primary" style="font-size: 2rem;" v-b-tooltip.hover :title="'Download do arquivo'"></i>
          </b-button>
          <b-button variant="light" v-if="hasRole(roles.RW_OPER_PCI_DOCUMENTATION)" @click="onClickFinancFile">
            <i class="fas fa-upload text-third" style="font-size: 2rem;" v-b-tooltip.hover :title="'Upload de arquivo'"></i>
          </b-button>
        </div>
        <b-form-input id="txtFinancAnnex" disabled v-if="financObj" v-model="financObj.nome"></b-form-input>
      </div>
    </b-card>
    <b-card class="mb-0">
      <template #header>
        <strong>{{'Documentação do Contrato'}}</strong>
      </template>
      <div class="d-flex flex-column justify-content-center">
        <div class="align-self-center p-2">
          <b-button variant="light" v-if="(hasRole(roles.RW_OPER_PCI_DOCUMENTATION) || hasRole(roles.R_OPER_PCI_DOCUMENTATION))" @click="onShowZDocs" >
            <i class="fas fa-folder-open text-warning" style="font-size: 2rem;" v-b-tooltip.hover :title="$lang.PCI.Spreadsheet.ContractDocumentation"></i>
          </b-button>
        </div>
      </div>
    </b-card>
  </b-modal>
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'
import Roles from '@/shared/utils/roles'
import PermissionMixin from '@/store/module/permission/mixin'
import CompanyPciDocsRepository from '@/shared/http/repositories/pci/companyPciDocs'
import CompanyMixin from '@/store/module/company/mixin'
import GedFolderRepository from '@/shared/http/repositories/business/gedfolder'

export default {
  name: 'Annex',
  props: {
    mode: {
      type: String,
      default: 'default'
    }
  },
  mixins: [PermissionMixin, CompanyMixin],
  components: {},
  data () {
    return {
      contract: {},
      contracts: [],
      financObj: null,
      plannerObj: null,
      removefinancObj: null,
      removeplannerObj: null,
      roles: Roles,
      showSelection: true
    }
  },
  methods: {
    show (contracts) {
      this.contracts = contracts
      this.contract = contracts[0]
      if (this.mode === 'multi-contract') {
        this.showSelection = false
      }
      if (this.mode === 'default' || this.mode === 'multi-contract') {
        this.onLoadContract()
      }
    },
    onLoadContract () {
      loading.push()
      WorkPCIRepository.GetAnnex(this.contract.contratoId)
        .then(response => {
          if (response.data.code > 0) {
            const annexes = response.data.data

            this.plannerObj = annexes.filter(f => f.tipoAnexo === 1)[0]
            this.financObj = annexes.filter(f => f.tipoAnexo === 0)[0]

            this.$refs.modal.show()
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onHide () {
      this.$refs.modal.hide()
      this.$emit('close')
    },
    createBoxConfirm (title) {
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelApprove
        ]),
        h('br')
      ])

      return this.$bvModal.msgBoxConfirm([messageVNode], {
        title: title,
        centered: true,
        okTitle: this.$lang.Yes,
        cancelTitle: this.$lang.No,
        headerClass: 'justify-content-center'
      })
    },
    onRemovePlannerFile () {
      this.createBoxConfirm(this.$lang.Common.ConfirmDelete)
        .then(value => {
          if (value) {
            loading.push()
            WorkPCIRepository.RemoveAnnex(this.plannerObj.id)
              .then(response => {
                if (response.data.code > 0) {
                  this.plannerObj = null
                } else {
                  toast.error(this.$lang.Common.Alerts.Error)
                }
              })
              .catch(err => {
                console.log(err)
                toast.error(this.$lang.Common.Alerts.Error)
              })
              .finally(() => loading.close())
          }
        })
    },
    onClickPlannerFile () {
      this.$refs.plannerFile.click()
    },
    onUploadPlannerFile (evt) {
      const file = evt.target.files[0]
      if (!file) return

      this.plannerObj = this.plannerObj || {
        id: '00000000-0000-0000-0000-000000000000',
        contratoID: this.contract.contratoId,
        tipoAnexo: 1
      }

      if (this.mode === 'multi-contract') {
        this.plannerObj.contracts = this.contracts
      }

      this.$set(this.plannerObj, 'nome', file.name)

      const form = new FormData()
      form.append('file', file)
      form.append('jsonString', JSON.stringify(this.plannerObj))

      loading.push()
      WorkPCIRepository.SaveAnnex(form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.data.code > 0) {
            this.plannerObj = response.data.data
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onDownloadPlanner () {
      loading.push()
      WorkPCIRepository.DownloadAnnex(this.plannerObj.id)
        .then(response => {
          if (response.data.code > 0) {
            const data = Uint8Array.from(atob(response.data.data.file), c => c.charCodeAt(0))
            const blob = new Blob([data], {type: response.data.data.contentType})
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.plannerObj.nome
            link.click()
            URL.revokeObjectURL(link.href)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onRemoveFinancFile () {
      this.createBoxConfirm(this.$lang.Common.ConfirmDelete)
        .then(value => {
          if (value) {
            loading.push()
            WorkPCIRepository.RemoveAnnex(this.financObj.id)
              .then(response => {
                if (response.data.code > 0) {
                  this.financObj = null
                } else {
                  toast.error(this.$lang.Common.Alerts.Error)
                }
              })
              .catch(err => {
                console.log(err)
                toast.error(this.$lang.Common.Alerts.Error)
              })
              .finally(() => loading.close())
          }
        })
    },
    onClickFinancFile () {
      this.$refs.financFile.click()
    },
    onUploadFinancFile (evt) {
      const file = evt.target.files[0]
      if (!file) return

      this.financStatus = this.financStatus === 'EMPTY' ? 'ADD' : 'UPDATE'

      this.financObj = this.financObj || {
        id: '00000000-0000-0000-0000-000000000000',
        contratoID: this.contract.contratoId,
        tipoAnexo: 0
      }

      if (this.mode === 'multi-contract') {
        this.financObj.contracts = this.contracts
      }

      this.$set(this.financObj, 'nome', file.name)

      const form = new FormData()
      form.append('file', file)
      form.append('jsonString', JSON.stringify(this.financObj))

      loading.push()
      WorkPCIRepository.SaveAnnex(form)
        .then(response => {
          if (response.data.code > 0) {
            this.financObj = response.data.data
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onDownloadFinanc () {
      loading.push()
      WorkPCIRepository.DownloadAnnex(this.financObj.id)
        .then(response => {
          if (response.data.code > 0) {
            const data = Uint8Array.from(atob(response.data.data.file), c => c.charCodeAt(0))
            const blob = new Blob([data], {type: response.data.data.contentType})
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.financObj.nome
            link.click()
            URL.revokeObjectURL(link.href)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onShowZDocs () {
      const base = process.env.ZDocsURL
      if (!base) {
        toast.error('ZDocs não configurado neste ambiente')
        return
      }
      // Abre a aba já no clique (gesto do usuário) e navega após resolver a pasta do contrato —
      // window.open dentro do .then seria barrado como popup. Vincular pasta = fase 2 (postMessage).
      const win = window.open('', '_blank')
      CompanyPciDocsRepository.Get(this.company.id)
        .then(response => {
          if (response.data.code <= 0) { if (win) win.close(); return }
          return GedFolderRepository.GetAllByFolder(response.data.data.gedPastaID)
            .then(r2 => {
              if (r2.data.code <= 0) { if (win) win.close(); return }
              const folder = r2.data.data.filter(f => f.nome === this.contract.referenciaContrato.substring(4))[0]
              if (!folder) {
                toast.error('Pasta não encontrada!')
                if (win) win.close()
                return
              }
              const url = `${base}/#/documentos?empresaId=${this.company.id}&pastaId=${folder.id}`
              if (win) win.location.href = url
              else window.open(url, '_blank', 'noopener,noreferrer')
            })
        })
        .catch(() => { if (win) win.close() })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/annex/annex.vue